export default "/images/vendor/flag-icon-css/flags/1x1/by.svg?da99aaa559633b439aa30c100f14cfbb";